// Limits shared by every prompt textarea (home hero, /explore hero, /create intro):
// `maxlength` enforces the max, and the "n/500" counter only shows past the threshold.
export const PROMPT_MAX_LENGTH = 500
export const PROMPT_COUNT_THRESHOLD = 200

export const showPromptCount = (length: number): boolean => length > PROMPT_COUNT_THRESHOLD

export const formatPromptCount = (length: number): string => `${length}/${PROMPT_MAX_LENGTH}`

// `maxlength` stops typing at the limit, so reaching it is a signal, not an error: the
// field just changes color and the submit stays enabled.
export const isPromptAtLimit = (length: number): boolean => length >= PROMPT_MAX_LENGTH
